import getSpamScenarioStore from '../selectors/getSpamScenarioStore';
import { SpamScenarioId } from 'owa-junkmail-configuration';
import { mutatorAction } from 'satcheljs';

export const setSearchQuery = mutatorAction(
    'setSearchQuery',
    (spamScenarioId: SpamScenarioId, searchQuery: string) => {
        const store = getSpamScenarioStore(spamScenarioId);
        store.searchQuery = searchQuery;
    }
);
